import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Observable, throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Category} from '../models/category';
import {environment} from '../../environments/environment';
import {TranslationService} from './translation.service';
import {CITY} from "../tokens";

@Injectable({
    providedIn: 'root'
})
export class HelperService {

    topLinks: {};

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId: Object,
        private http: HttpClient,
        private translationService: TranslationService,
        @Inject(CITY) private injectedCity: string
    ) {
      this.topLinks = {
        sofia: {
            mediterranean: '1/Selekcii-zavedeniya/news/7364',// Средиземноморска кухня
            clubs: '1/Selekcii-zavedeniya/news/10353',// Нощни клубове
            fishRestourants: '',
            topRestaurants: '1/Selekcii-zavedeniya/news/7510',// Изискани ресторанти
            bulgarianPubs: '1/Selekcii-zavedeniya/news/7594',// Механи
            pizza: '1/Selekcii-zavedeniya/news/7596',// Пицарии
            bars: '1/Selekcii-zavedeniya/news/7651',// Барове
            barAndDinner: '1/Selekcii-zavedeniya/news/10508',// Бар и Динър
            special: '1/Selekcii-zavedeniya/news/7594',// Селекции заведения
            delivery: '',// Заведения с доставка
            beerVenues: '',
        },

        plovdiv: {
            mediterranean: '0/Selekcii-zavedeniya/news/1523',// Средиземноморска кухня
            clubs: '0/Selekcii-zavedeniya/news/1546',// Нощни клубове
            fishRestourants: '',
            topRestaurants: '0/Selekcii-zavedeniya/news/1522',// Изискани ресторанти
            bulgarianPubs: '0/Selekcii-zavedeniya/news/1525',// Механи
            pizza: '0/Selekcii-zavedeniya/news/1524',// Пицарии
            bars: '0/Selekcii-zavedeniya/news/1526',// Барове
            barAndDinner: '0/Selekcii-zavedeniya/news/1547',// Бар и Динър
            special: '',// Селекции заведения
            beerVenues: '',
            delivery: ''// Заведения с доставка
        },

        varna: {
            mediterranean: '',// Средиземноморска кухня
            clubs: '1/Selekcii-zavedeniya/news/2121',// Нощни клубове
            fishRestourants: '1/Selekcii-zavedeniya/news/3937',
            topRestaurants: '1/Selekcii-zavedeniya/news/2118',// Изискани ресторанти
            bulgarianPubs: '1/Selekcii-zavedeniya/news/2119',// Механи
            pizza: '1/Selekcii-zavedeniya/news/2132',// Пицарии
            bars: '1/Selekcii-zavedeniya/news/2120',// Барове
            barAndDinner: '1/Selekcii-zavedeniya/news/2915',// Бар и Динър
            special: '',// Селекции заведения
            beerVenues: '1/Selekcii-zavedeniya/news/2668',
            delivery: ''// Заведения с доставка
        },

        burgas: {
            mediterranean: '',// Средиземноморска кухня
            clubs: '',// Нощни клубове
            fishRestourants: '',
            topRestaurants: '0/Selekcii-zavedeniya/news/174',// Изискани ресторанти
            bulgarianPubs: '',// Механи
            pizza: '',// Пицарии
            bars: '0/Selekcii-zavedeniya/news/176',// Барове
            barAndDinner: '',// Бар и Динър
            special: '',// Селекции заведения
            delivery: '0/Selekcii-zavedeniya/news/173'// Заведения с доставка
        },

        tarnovo: {
            mediterranean: '',// Средиземноморска кухня
            clubs: '',// Нощни клубове
            fishRestourants: '',
            topRestaurants: '',// Изискани ресторанти
            bulgarianPubs: '',// Механи
            pizza: '',// Пицарии
            bars: '',// Барове
            barAndDinner: '',// Бар и Динър
            special: '',// Селекции заведения
            beerVenues: '',
            delivery: ''// Заведения с доставка
        },

        bansko: {
            mediterranean: '',// Средиземноморска кухня
            clubs: '',// Нощни клубове
            fishRestourants: '',
            topRestaurants: '',// Изискани ресторанти
            bulgarianPubs: '',// Механи
            pizza: '',// Пицарии
            bars: '',// Барове
            barAndDinner: '',// Бар и Динър
            special: '',// Селекции заведения
            beerVenues: '',
            delivery: ''// Заведения с доставка
        },

        bulgaria: {
            mediterranean: '',// Средиземноморска кухня
            clubs: '',// Нощни клубове
            fishRestourants: '',
            topRestaurants: '',// Изискани ресторанти
            bulgarianPubs: '',// Механи
            pizza: '',// Пицарии
            bars: '',// Барове
            barAndDinner: '',// Бар и Динър
            special: '',// Селекции заведения
            beerVenues: '',
            delivery: ''// Заведения с доставка
        }

    };

    }

    markSelectedCity() {
        let currentCitySelected = this.injectedCity || this.getCity();
        if (currentCitySelected == null) {
            currentCitySelected = 'sofia';
        }

        switch (currentCitySelected) {
            case null:
                this.document.getElementById('zavedenia.com home').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'City <i class="fa fa-caret-down"></i>';
                break;
            case "sofia":
                this.document.getElementById('sofia').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'София <i class="fa fa-caret-down"></i>';
                break;
            case "plovdiv":
                this.document.getElementById('plovdiv').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'Пловдив <i class="fa fa-caret-down"></i>';
                break;
            case "varna":
                this.document.getElementById('varna').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'Варна <i class="fa fa-caret-down"></i>';
                break;
            case "burgas":
                this.document.getElementById('burgas').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'Бургас <i class="fa fa-caret-down"></i>';
                break;
            case "tarnovo":
                this.document.getElementById('tarnovo').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'Велико Търново <i class="fa fa-caret-down"></i>';
                break;
            case "bansko":
                this.document.getElementById('bansko').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'Банско <i class="fa fa-caret-down"></i>';
                break;
            case "skopje":
                this.document.getElementById('skopje').classList.add('selected');
                this.document.getElementById('choose-city').innerHTML = 'Скопие <i class="fa fa-caret-down"></i>';
                break;
            default:
                break;
        }
    }

    capitalizeFirstLetter(input: string) {
        return input.charAt(0).toUpperCase() + input.slice(1);
    }

    getHost() {
      if(!isPlatformBrowser(this.platformId)){
        return;
      }

      const host = this.document.defaultView.location.hostname;
      const splitted = host.split('.');
      let final = '';
      if (splitted.length > 1) {
          final = splitted[1];
      } else {
          final = splitted[0];
      }

      if (final === "localhost") {
          final += ":4200";
      }
      else if (final !== "localhost") {
          final += ".com";
      }

      return final;
  }
      getCity(): string {
        const host = this.document.location.host;
        if (host.split('.').length === 1) {
            return 'sofia';
        }
        return host.split('.')[0];
    }

    translateCity(): any {
      return [
           {
               "sofia": {
                   "bg": "София",
                   "en": "Sofia"
               },
               "plovdiv": {
                   "bg": "Пловдив",
                   "en": "plovdiv",
               },
               "varna": {
                   "bg": "Варна",
                   "en": "varna"
               },
               "burgas": {
                   "bg": "Бургас",
                   "en": "burgas",
               },
               "tarnovo": {
                   "bg": "В Търново",
                   "en": "tarnovo",
               },
               "bansko": {
                   "bg": "Банско",
                   "en": "bansko",
               },
               "skopje": {
                   "bg": "Скопие",
                   "en": "Skopje",
               },
               "beograd": {
                   "bg": "Београд",
                   "en": "Beograd",
               }
           }
       ]
    }

    getNumberOfPages(itemsCount: number, itemsPerPage: number): number {

        const pages = Math.ceil(itemsCount / itemsPerPage);
        return pages;
    }

    pageRange(page: number, pageCount: number, mobile: boolean) {

        let start = page - (mobile ? 1 : 2);
        let end = page + (mobile ? 1 : 2);

        if (end > pageCount) {
            start -= (end - pageCount);
            end = pageCount;
        }
        if (start <= 0) {
            end += ((start - 1) * (-1));
            start = 1;
        }

        end = end > pageCount ? pageCount : end;

        return {
            start: start - 1,
            end: end
        };
    }

    toLatin(word: string): string {
        if (word != null) {
            word = word.trim();
            let answer = "", a = {};

              a["а"] = "a"; a["б"] = "b"; a["в"] = "v";
              a["г"] = "g"; a["д"] = "d"; a["е"] = "e";
              a["ж"] = "j"; a["з"] = "z"; a["и"] = "i";
              a["й"] = "i"; a["к"] = "k"; a["л"] = "l";
              a["м"] = "m"; a["н"] = "n"; a["о"] = "o";
              a["п"] = "p"; a["р"] = "r"; a["с"] = "s";
              a["т"] = "t"; a["у"] = "u"; a["ф"] = "f";
              a["х"] = "h"; a["ц"] = "c"; a["ч"] = "ch";
              a["ш"] = "sh"; a["щ"] = "sht"; a["ъ"] = "y";
              a["ь"] = ""; a["ю"] = "yu"; a["я"] = "ya";

              a["ѓ"] = "gj"; a["ѕ"] = "dz"; a["ј"] = "j";
              a["љ"] = "lj"; a["њ"] = "nj"; a["ќ"] = "kj";
              a["џ"] = "dj";

              a["А"] = "A"; a["Б"] = "B"; a["В"] = "V";
              a["Г"] = "G"; a["Д"] = "D"; a["Е"] = "E";
              a["Ж"] = "J"; a["З"] = "Z"; a["И"] = "I";
              a["Й"] = "I"; a["К"] = "K"; a["Л"] = "L";
              a["М"] = "M"; a["Н"] = "N"; a["О"] = "O";
              a["П"] = "P"; a["Р"] = "R"; a["С"] = "S";
              a["Т"] = "T"; a["У"] = "U"; a["Ф"] = "F";
              a["Х"] = "H"; a["Ц"] = "C"; a["Ч"] = "Ch";
              a["Ш"] = "Sh"; a["Щ"] = "Sht"; a["Ъ"] = "";
              a["Ю"] = "Yu"; a["Я"] = "Ya";

              a["Ѓ"] = "Gj"; a["Ѕ"] = "Dz"; a["Ј"] = "J";
              a["Љ"] = "Lj"; a["Њ"] = "Nj"; a["Ќ"] = "Kj";
              a["Џ"] = "Dj";

              a["a"] = "a"; a["b"] = "b"; a["c"] = "c"; a["d"] = "d";
              a["e"] = "e"; a["f"] = "f"; a["g"] = "g"; a["h"] = "h";
              a["i"] = "i"; a["j"] = "j"; a["k"] = "k"; a["l"] = "l";
              a["m"] = "m"; a["n"] = "n"; a["o"] = "o"; a["p"] = "p";
              a["q"] = "q"; a["r"] = "r"; a["s"] = "s"; a["t"] = "t";
              a["u"] = "u"; a["v"] = "v"; a["w"] = "w"; a["x"] = "x";
              a["y"] = "y"; a["z"] = "z";

              a["A"] = "A"; a["B"] = "B"; a["C"] = "C"; a["D"] = "D";
              a["E"] = "E"; a["F"] = "F"; a["G"] = "G"; a["H"] = "H";
              a["I"] = "I"; a["J"] = "J"; a["K"] = "K"; a["L"] = "L";
              a["M"] = "M"; a["N"] = "N"; a["O"] = "O"; a["P"] = "P";
              a["Q"] = "Q"; a["R"] = "R"; a["S"] = "S"; a["T"] = "T";
              a["U"] = "U"; a["V"] = "V"; a["W"] = "W"; a["X"] = "X";
              a["Y"] = "Y"; a["Z"] = "Z";

              a["1"] = "1"; a["2"] = "2"; a["3"] = "3"; a["4"] = "4";
              a["5"] = "5"; a["6"] = "6"; a["7"] = "7"; a["8"] = "8";
              a["9"] = "9"; a["0"] = "0";

              a["`"] = ""; a["~"] = ""; a["!"] = ""; a["@"] = "";
              a["#"] = ""; a["$"] = ""; a["%"] = ""; a["^"] = "";
              a["&"] = ""; a["*"] = ""; a["("] = ""; a[")"] = "";
              a["-"] = ""; a["_"] = ""; a["="] = ""; a["+"] = "";
              a["/"] = ""; a["?"] = ""; a["<"] = ""; a[">"] = "";
              a[","] = ""; a[":"] = ""; a[";"] = ""; a["'"] = "";
              a['"'] = "";

            for (let i = 0; i < word.length; i++) {
                if (word?.hasOwnProperty(i)) {
                    if (a[word[i]] === undefined && word[i] != "-") {
                        answer += '-';
                    } else {
                        answer += a[word[i]];
                    }
                }

                if (answer.indexOf('..') != -1) {
                    answer = answer.replace('..', '.');
                }
            }

            if (answer.indexOf('..') != -1) {
                answer = answer.replace('..', '.');
            }

            return answer;
        } else {
            return '';
        }
    }
    public getIpClient(): Observable<any>{
      return this.http.get('https://api.ipify.org/?format=json');
    }

      sendTurnOfGoogleReserveEmail(routeParam): Observable<any> {
        const city = this.injectedCity || this.getCity();
        const language = this.translationService.language;
        return this.http.post(`${environment.API_URL}feedback/${city}/${language}/`, routeParam);
      }

  urlify(text) {
    if (text.search(/<a\s+[^>]*href\s*=\s*["'”]([^"'”]+)["'”][^>]*>/) > 0) {
      // this link doens't have a title
      let newText = text.replace(/”/g, "")
      return newText;
    } else if (text.search(/<a\s+[^>]*href\s*=\s*["'”]([^"']+)[”"'][^>]*>(?:[^<]*<[^>]*title\s*=\s*["']([^"']+)["'][^>]*>)?/) > 0) {
      // this handles if the link has a title
      let newText = text.replace(/”/g, "")
      return  newText;
    }
    let Rexp =
      /(?<!src=")(\b(https?|ftp|file):\/\/([-A-Z0-9+&@#%?=~_|!:,.;]*)([-A-Z0-9+&@#%?\/=~_|!:,.;]*)[-A-Z0-9+&@#\/%=~_|])/ig;
    return text.replace(Rexp,
      "<a href='$1' target='_blank'>$3</a>");
  }
}


